import {
	TRIGGER_FETCH_POSTPE_CONTACT_LIST_API,
	TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS,
} from 'redux/actionTypes';

export function triggerFetchPostPeContactListApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_POSTPE_CONTACT_LIST_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchPostPeContactListApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_POSTPE_CONTACT_LIST_API_SUCCESS,
		data,
	};
}
